import React from 'react';
import { faFacebook, faInstagram, faPinterest, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt, faPhone, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import LOGO from "../assets/Logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden">
      {/* Main Footer Background */}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100">

        {/* Newsletter Section */}
        <div className="border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6 py-12">
            <div className="text-center max-w-2xl mx-auto">
              <h2 className="text-3xl font-light text-gray-800 mb-4">Stay Connected</h2>
              <p className="text-gray-600 mb-8">Subscribe to get the latest updates on our premium textile collections and exclusive offers.</p>

              <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="flex-1 px-4 py-3 rounded-md bg-white border-2 border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-300"
                />
                <button className="px-6 py-3 bg-teal-600 text-white font-medium rounded-md hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl">
                  Subscribe
                  <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">

            {/* Brand Section */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <div className="text-4xl font-bold text-gray-800 mb-2">
                  <img src={LOGO} alt="Fabric Most Trusted Logo" className="h-20 inline-block" />
                </div>
                <h3 className="text-xl font-light text-gray-800 mb-2 tracking-wide">Fabric Most Trusted</h3>
                <p className="text-teal-600 text-sm font-medium">EST. 2010</p>
              </div>

              <p className="text-gray-600 leading-relaxed mb-8">
                Discover premium fabrics that combine traditional craftsmanship with innovative design. Your trusted partner in quality textiles.
              </p>

              <div className="flex gap-3">
                {[
                  { icon: faFacebook, href: '#' },
                  { icon: faInstagram, href: '#' },
                  { icon: faTwitter, href: '#' },
                  { icon: faLinkedin, href: '#' },
                  { icon: faPinterest, href: '#' }
                ].map(({ icon, href }, index) => (
                  <a
                    key={index}
                    href={href}
                    className="w-10 h-10 rounded-md border-2 border-gray-200 flex items-center justify-center text-gray-500 hover:text-teal-600 hover:border-teal-600 hover:bg-teal-50 transition-all duration-300"
                  >
                    <FontAwesomeIcon icon={icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-gray-800 font-medium text-lg mb-6">
                Quick Links
              </h4>

              <div className="space-y-3">
                {[
                  { name: 'Home', path: '/' },
                  { name: 'About Us', path: '/about' },
                  { name: 'Products', path: '/products' },
                  { name: 'Category', path: '/category' },
                  { name: 'Contact', path: '/contact' },
                  { name: 'Dashboard', path: '/dashboard' }
                ].map(item => (
                  <a
                    key={item.name}
                    href={item.path}
                    onClick={() => window.scrollTo(0, 0)}
                    className="group flex items-center text-gray-600 hover:text-teal-600 transition-all duration-300"
                  >
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-xs text-gray-400 group-hover:text-teal-600 mr-3 transform group-hover:translate-x-1 transition-all duration-300"
                    />
                    {item.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-gray-800 font-medium text-lg mb-6">
                Our Services
              </h4>

              <div className="space-y-3">
                {[
                  'Stitch Fabric',
                  'Synthetics Wool',
                  'Cotton Velvet',
                  'Satin Weaving',
                  'Custom Design',
                  'Bulk Orders'
                ].map(item => (
                  <a
                    key={item}
                    href="#"
                    className="block text-gray-600 hover:text-teal-600 transition-all duration-300 py-1"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-gray-800 font-medium text-lg mb-6">
                Contact Information
              </h4>

              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="text-teal-600 mt-1 mr-3" />
                  <p className="text-gray-600">
                    Millennium Textile Market,<br />
                    Sahara Darwaja,<br />
                    Surat, Gujarat
                  </p>
                </div>

                <div className="flex items-center">
                  <FontAwesomeIcon icon={faPhone} className="text-teal-600 mr-3" />
                  <p className="text-gray-600">+91 9876543210</p>
                </div>

                <div className="flex items-center">
                  <FontAwesomeIcon icon={faEnvelope} className="text-teal-600 mr-3" />
                  <p className="text-gray-600">growtextile15@gmail.com</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 bg-white">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-500 text-sm">
                © {currentYear} Fabric Most Trusted. All rights reserved.
              </p>

              <div className="flex gap-6 text-sm">
                <a href="#" className="text-gray-500 hover:text-teal-600 transition-colors duration-300">Privacy Policy</a>
                <span className="text-gray-300">|</span>
                <a href="#" className="text-gray-500 hover:text-teal-600 transition-colors duration-300">Terms of Service</a>
                <span className="text-gray-300">|</span>
                <a href="#" className="text-gray-500 hover:text-teal-600 transition-colors duration-300">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
